module.exports = __webpack_public_path__ + "assets/img/vantagens.8abbb993.svg";